import React from 'react';
import { Link } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function CleaningBookingCancel() {
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center p-4" data-testid="cleaning-booking-cancel">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-red-500" />
        </div>
        <h1 className="text-3xl font-bold text-slate-900 font-['Outfit'] mb-3">Booking Cancelled</h1>
        <p className="text-slate-500 mb-8">Your payment was not completed. You can try again anytime.</p>
        <Link to="/cleaning/booking">
          <Button className="bg-emerald-500 hover:bg-emerald-600 text-white px-8">Try Again</Button>
        </Link>
      </div>
    </div>
  );
}
